import axios from "axios";
import { CurrentSiteIdGet } from "./userSettings";

export const apiConfigureLoggerChannel = async (serialNumber, channelNumber, highSet, highStart, lowSet, lowStart, alarmDelay, smsGroup, name, log) => {
	const siteId = CurrentSiteIdGet();

	try {
		await axios({
			method: "post",
			url: "v2/Configure/LoggerChannel",
			data: { siteId, serialNumber, channelNumber, highSet, highStart, lowSet, lowStart, alarmDelay, smsGroup, name, log },
		});
	} catch (err) {
		console.error(err);
	}
};

export const apiOutstandingLoggerChannelConfiguration = async (serialNumber) => {
	const siteId = CurrentSiteIdGet();

	try {
		return await axios({
			method: "get",
			url: "v2/Configure/OutstandingLoggerChannel",
			params: { siteId, serialNumber },
		});
	} catch (err) {
		console.error(err);
	}
};

export const apiSQIRequest = async (serialNumber) => {
	const siteId = CurrentSiteIdGet();

	try {
		return await axios({
			method: "post",
			url: "v2/Configure/SqiRequest",
			data: { siteId, serialNumber },
		});
	} catch (err) {
		console.error(err);
	}
};

export const apiSQIRequestOutstanding = async (serialNumber) => {
	const siteId = CurrentSiteIdGet();

	try {
		return await axios({
			method: "get",
			url: "v2/Configure/OutstandingSqiRequest",
			params: { siteId, serialNumber },
		});
	} catch (err) {
		console.error(err);
	}
};

export const apiSQIUpload = async (serialNumber, full, base64String) => {
	const siteId = CurrentSiteIdGet();

	try {
		return await axios({
			method: "post",
			url: "v2/Configure/SqiUpload",
			data: { siteId, serialNumber, full, base64String },
		});
	} catch (err) {
		console.error(err);
	}
};

export const apiSQIUploadOutstanding = async (serialNumber) => {
	const siteId = CurrentSiteIdGet();

	try {
		return await axios({
			method: "get",
			url: "v2/Configure/OutstandingSqiUpload",
			params: { siteId, serialNumber },
		});
	} catch (err) {
		console.error(err);
	}
};

export const apiSquirrelSMSNumbersGetList = async (serialNumber) => {
	const siteId = CurrentSiteIdGet();

	try {
		const result = await axios({
			method: "get",
			url: "v2/SquirrelSMSNumbers",
			params: { siteId, serialNumber },
		});

		return result.data;
	} catch (err) {
		console.error(err);
	}
};

export const apiSquirrelEmailsGetList = async (serialNumber) => {
	const siteId = CurrentSiteIdGet();

	try {
		const result = await axios({
			method: "get",
			url: "v2/SquirrelEmails",
			params: { siteId, serialNumber },
		});

		return result.data;
	} catch (err) {
		console.error(err);
	}
};

export const apiConfigureLoggerSMSNumbers = async (serialNumber, smsNumbers) => {
	const siteId = CurrentSiteIdGet();

	try {
		await axios({
			method: "post",
			url: "v2/Configure/LoggerSMSNumbers",
			data: { siteId, serialNumber, smsNumbers },
		});
	} catch (err) {
		console.error(err);
	}
};

// Which cloud alarms each SMS contact receives. Deliberately separate from apiConfigureLoggerSMSNumbers:
// the phone numbers are the logger's own configuration and are queued for the device to collect, while
// these flags are a Darca Connect setting and apply as soon as they are saved.
export const apiSquirrelSMSNumbersNotifySave = async (serialNumber, SquirrelSMSNumbers) => {
	const siteId = CurrentSiteIdGet();

	await axios({
		method: "post",
		url: "v2/SquirrelSMSNumbers/Notify",
		data: { siteId, serialNumber, SquirrelSMSNumbers },
	});
};

// The email-only twin of apiSquirrelSMSNumbersNotifySave. Sends the flags alone, so setting a recipient
// from the Notifications panel cannot also write an unsaved edit sitting in the Emails Only table.
export const apiSquirrelEmailsNotifySave = async (serialNumber, SquirrelEmails) => {
	const siteId = CurrentSiteIdGet();

	await axios({
		method: "post",
		url: "v2/SquirrelEmails/Notify",
		data: { siteId, serialNumber, SquirrelEmails },
	});
};

export const apiSquirrelEmailsSave = async (serialNumber, SquirrelEmails) => {
	const siteId = CurrentSiteIdGet();

	try {
		await axios({
			method: "post",
			url: "v2/SquirrelEmails",
			data: { siteId, serialNumber, SquirrelEmails },
		});
	} catch (err) {
		console.error(err);
	}
};

export const apiOutstandingLoggerSMSNumbersConfiguration = async (serialNumber) => {
	const siteId = CurrentSiteIdGet();

	try {
		return await axios({
			method: "get",
			url: "v2/Configure/OutstandingLoggerSMSNumbers",
			params: { siteId, serialNumber },
		});
	} catch (err) {
		console.error(err);
	}
};
